const stockTemplate = {
    SKUId: 0,
    ProductTitle: "",
    ClipWeight: "",
    ClipQuantity: "",
    ItemCode: "",
    HSNCode: "",
    Description: "",
    ProductCode: "",
    MetalName: "",
    CategoryId: 0,
    ProductId: 0,
    DesignId: 0,
    PurityId: 0,
    Colour: "",
    Size: "",
    WeightCategory: null,
    GrossWt: "",
    NetWt: "",
    CollectionName: "",
    OccassionName: "",
    Gender: "",
    MakingFixedAmt: "",
    MakingPerGram: "",
    MakingFixedWastage: "",
    MakingPercentage: "",
    TotalStoneWeight: "",
    TotalStoneAmount: "",
    TotalStonePieces: "",
    TotalDiamondWeight: "",
    TotalDiamondPieces: "",
    TotalDiamondAmount: "",
    Featured: "",
    Pieces: "",
    HallmarkAmount: "",
    HUIDCode: "",
    MRP: "",
    VendorId: 0,
    VendorName: "",
    FirmName: "",
    BoxId: 0,
    TIDNumber: "",
    RFIDCode: "",
    FinePercent: "",
    WastagePercent: "",
    Images: null,
    BlackBeads: "",
    Height: "",
    Width: "",
    OrderedItemId: null,
    CuttingGrossWt: "",
    CuttingNetWt: "",
    MetalRate: "",
    LotNumber: "",
    DeptId: 0,
    PurchaseCost: "",
    Margin: "",
    BranchName: "",
    BoxName: "",
    EstimatedDays: "",
    OfferPrice: "",
    Rating: "",
    SKU: "",
    Ranking: "",
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    EmployeeId: 0,
    Status: "",
    ClientCode: "",
    UpdatedFrom: "",
    count: 0,
    MetalId: 0,
    WarehouseId: 0,
    CreatedOn: "",
    LastUpdated: "",
    TaxId: 0,
    TaxPercentage: "",
    OtherWeight: "",
    PouchWeight: "",
    CategoryName: "",
    PurityName: "",
    TodaysRate: "",
    ProductName: "",
    DesignName: "",
    DiamondSize: "",
    DiamondWeight: "",
    DiamondPurchaseRate: "",
    DiamondSellRate: "",
    DiamondClarity: "",
    DiamondColour: "",
    DiamondShape: "",
    DiamondCut: "",
    DiamondSettingType: "",
    DiamondCertificate: "",
    DiamondPieces: "",
    DiamondPurchaseAmount: "",
    DiamondSellAmount: "",
    DiamondDescription: "",
    TagWeight: "",
    FindingWeight: "",
    LanyardWeight: "",
    PacketId: 0,
    PacketName: "",
    CollectionId: 0,
    CollectionNameSKU: null,
    PackingWeight: 0.0,
    Stones: [],
    Diamonds: [],
  };
  
  export default stockTemplate;
  